/**
 * 붙여쓴 검색어를 스크립트 경계에서 분리한다.
 *
 * 사용자는 "聖水kpop", "갤럭시s25"처럼 문자 체계가 바뀌는 지점을 공백 없이
 * 입력하는 경우가 많다. DB의 전문 검색·키워드 매칭은 토큰 단위라 이런 입력이
 * 0건으로 떨어지므로, CJK ↔ 라틴/숫자 경계에 공백을 넣어 재시도할 수 있게 한다.
 *
 * 라틴 ↔ 숫자 경계는 분리하지 않는다 — "s25", "X100VI", "GALAXYs24"는
 * 하나의 모델명이라 쪼개면 오히려 검색이 망가진다.
 */

/**
 * CJK 문자 범위: 한글 자모(ᄀ-ᇿ)·호환 자모(㄰-㆏)·음절(가-힯),
 * 가나(぀-ヿ), 한자 통합(一-鿿)·확장A(㐀-䶿)·호환(豈-﫿).
 * 리터럴 CJK 대신 \uXXXX 이스케이프로 적어 인코딩 사고를 막는다.
 * 검색 가이드 매칭(`_data/related-guides.ts`)도 이 상수를 공유해 범위가 갈리지 않게 한다.
 */
export const CJK_RANGE =
  "\\u1100-\\u11FF\\u3040-\\u30FF\\u3130-\\u318F\\u3400-\\u4DBF\\u4E00-\\u9FFF\\uAC00-\\uD7AF\\uF900-\\uFAFF";

/** 라틴 문자와 숫자는 한 덩어리로 취급 (모델명 보호). */
const LATIN_RANGE = "A-Za-z0-9";

const CJK_THEN_LATIN = new RegExp(`([${CJK_RANGE}])([${LATIN_RANGE}])`, "g");
const LATIN_THEN_CJK = new RegExp(`([${LATIN_RANGE}])([${CJK_RANGE}])`, "g");

/**
 * CJK ↔ 라틴/숫자 경계 양방향에 공백을 넣고 연속 공백을 정리한다.
 *
 *   "聖水kpop"     → "聖水 kpop"
 *   "kpop聖水"     → "kpop 聖水"
 *   "갤럭시s25"    → "갤럭시 s25"
 *   "明洞kpop카페" → "明洞 kpop 카페"
 *   "GALAXYs24"    → "GALAXYs24"  (라틴↔숫자는 유지)
 *
 * 경계가 없으면 공백 정리·trim만 적용된 원문이 그대로 돌아온다.
 */
export function insertScriptBoundarySpaces(query: string): string {
  return query
    .replace(CJK_THEN_LATIN, "$1 $2")
    .replace(LATIN_THEN_CJK, "$1 $2")
    .replace(/\s+/g, " ")
    .trim();
}
